<template>

    <v-card>
        <v-toolbar flat color="#1c1d29"> 
            <v-toolbar-title>
                Live Settings
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <!-- Success Message -->
            <v-alert :value="updateSettingsForm.successful" type="success">
                Settings updated
            </v-alert>

            <v-form ref="form" role="form" @submit.prevent="saveSettings">
            <!-- Name -->
  
                <v-text-field outline label="Live Session Title" name="live_title" v-model="updateSettingsForm.live_title" :class="{'is-invalid': updateSettingsForm.errors.has('live_title')}"></v-text-field>

                <span class="invalid-feedback" v-show="updateSettingsForm.errors.has('live_title')">
                    @{{ updateSettingsForm.errors.get('live_title') }}
                </span>
    
                <v-textarea outline label="Live Session Description" name="live_description" v-model="updateSettingsForm.live_description" :class="{'is-invalid': updateSettingsForm.errors.has('live_description')}" rows="4"></v-textarea>

                <span class="invalid-feedback" v-show="updateSettingsForm.errors.has('live_description')">
                    @{{ updateSettingsForm.errors.get('live_description') }}
                </span>


                <v-text-field outline label="Live Chatroom Name (DONT CHANGE THIS)" name="live_chatroom" v-model="updateSettingsForm.live_chatroom" :class="{'is-invalid': updateSettingsForm.errors.has('live_chatroom')}"></v-text-field>

                <span class="invalid-feedback" v-show="updateSettingsForm.errors.has('live_chatroom')">
                    @{{ updateSettingsForm.errors.get('live_chatroom') }}
                </span>

            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="#4cc0ad" type="submit" :disabled="updateSettingsForm.busy" @click.prevent="saveSettings">Save</v-btn>
        </v-card-actions>
      </v-card>
  

</template>

<script>
 
    var updateSettingsForm = function () {
        return {
            live_title: '',
            live_description: '',
            live_chatroom: ''
        };
    };

    export default {
        data(){
            return {
                formSet: false,
                updateSettingsForm: new SparkForm(updateSettingsForm()),
                isUpdating: false
            }
        },
        created(){

            this.getSettings();


        },
        methods: {



            getSettings(){


                let self = this;

                axios.get('/api/settings').then((response) => {

                    console.log(response);

                    this.updateSettingsForm.live_title = response.data.live_title;
                    this.updateSettingsForm.live_description = response.data.live_description;
                    this.updateSettingsForm.live_chatroom = response.data.live_chatroom;

              

                    self.formSet = true;

                })

            },
 

            saveSettings(){

                /* passed validation, submit */
                this.updateSettingsForm.errors.forget();

                Spark.post('/api/settings', this.updateSettingsForm)
                .then((response) => {

                    console.log(response);

                }).catch((error) => {

                    this.updateSettingsForm.errors.set(error.errors);

                });


                
            }

        }
    }
</script>


<style scoped>
  

</style>